import { useState, useContext } from "react";
import TimeSpanComponent from "./TimeSpanComponent";
import { NetNewContext } from "./NetNewAccount";
import { PublicIcon } from "../../../assets/svg";
import Tooltip from '@mui/material/Tooltip';

export const NetNewTitleMenu = () => {
  const context = useContext(NetNewContext);
  const { isLoading, setIsLoading, selectedFrequency, setSelectedFrequency, fromDate, setFromDate, toDate, setToDate } = context;

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", marginLeft: "auto", gap: "8px" }}>
        {/* <p className="header-text">Distribution of Source based on ICP Level</p> */}
        <Tooltip title="This card does not support filter and segments" arrow>
          <div style={{ height: "14px" }}>
            <PublicIcon />
          </div>
        </Tooltip>
        <TimeSpanComponent
          frequencySelected={selectedFrequency}
          setFromDate={setFromDate}
          fromDate={fromDate}
          setToDate={setToDate}
          toDate={toDate}
          enableToRange={true}
          setIsLoading={setIsLoading}
          input="1"
          tool={"b2_net_new"}
        />
      </div>
    </>
  );
};
